import { Injectable } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {AttachmentUrlService} from "./attachment-url.service";

@Injectable({
  providedIn: 'root'
})
export class DataManipulationService {

  constructor(public translate: TranslateService, public attachmentUrlService: AttachmentUrlService) {
  }
  public addLocalizedAttributeToElement(element: any, attribute: string, specLocalizationName?:string) {
    let currentLang = this.translate.currentLang;
    if(!specLocalizationName){
      element[attribute] = element.localizations[currentLang]? element.localizations[currentLang][attribute] :"unknown";
    }else{
      element[attribute] = element[specLocalizationName][currentLang]?element[specLocalizationName][currentLang][attribute]:"unknown";
    }
    return element;
  }
  public addLocalizedAttributeToList(list:any[], attribute:string){
    list.forEach(element =>{
      element = this.addLocalizedAttributeToElement(element, attribute);
    });
    return list;
  }

  public addNameToElement(element: any, attributeName?: string){
    let currentLang = this.translate.currentLang;
    if(attributeName != undefined){
      let name = "";
      if(element[attributeName] != undefined) {
        name = element[attributeName].localizations[currentLang]?.name;
      } else {
        element[attributeName] = {};
      }
      element[attributeName].getName = function () {
        return name;
      };
      element[attributeName].name = name;
    }
    else{
      element.getName = function () {
        return element.localizations[currentLang]?.name;
      };
      element.name = element.localizations[currentLang]?.name;
    }
    return element;
  }

  public addNameToList(list: any[], attributeName?: string){
    for(let element of list){
      element = this.addNameToElement(element, attributeName)
    }
    return list;
  }

  public allAttachmentObjectManipulation(attachments:any) {
    for (let key in attachments) {
      let value = attachments[key];
      this.oneAttachmentManipulation(value.attachment);
    }
    return attachments;
  }

  public oneAttachmentManipulation(attachment){
    let that = this;
    attachment.getSrc = function(size){
      if(attachment.mimeType.match(/.+svg\+xml/g) || (attachment.mimeType.match(/image\/.+/g) && size == undefined)) {
        return that.attachmentUrlService.getSvgImageUrl(attachment.localization);
      }
      else if(attachment.mimeType.match(/image\/.+/g)) {
        return that.attachmentUrlService.getScaleWidthImageUrl(attachment.localization, size);
      }
      else if(attachment.mimeType.match(/video\/.+/g)) {
        return that.attachmentUrlService.getVideoUrl(attachment.localization);
      }
    };
    attachment.getTitle = function () {
      return attachment.localization[that.translate.currentLang]?.title;
    };
    attachment.isProductReady = function () {
      return (attachment.productReady == true ? '<i class="fa fa-check ml-2"></i>' : '<i class="fa fa-times ml-2"></i>');
    };
    attachment.getImage = function () {
      const regex = /image\/.+/g;
      if(attachment.mimeType.match(regex)) {
        if(attachment.mimeType.match(/.+svg\+xml/g)) {
          return '<img class="ml-2" src="' + that.attachmentUrlService.getSvgImageUrl(attachment.localization) + '" height="50"/>';
        }
        return '<img class="ml-2" src="' + that.attachmentUrlService.getScaleHeightImageUrl(attachment, 50) + '" height="50"/>';
      }else{
        return '<i style="font-size: 50px;" class="fa fa-file ml-2"></i>';
      }
    };
    attachment.downloadLink = this.attachmentUrlService.getDownloadUrl(attachment.localization);
    return attachment;
  }

  public addNameAttributeFromFirstAndLastName = function(user:any){
    if(user != null) {
      user.name = user.firstName + ' ' + user.lastName;
    }
  }
}
